import React from 'react';

import { styled } from '@mui/system';

import { H3 } from '@ui/heading';

const Text = styled(H3)(({ theme }) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
    fontWeight: 700,
    fontSize: '1.5rem',
}));

const Subtitle = ({ children }) => {
    return <Text gutterBottom>{children}</Text>;
};

export default Subtitle;
